/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { useSessionListByCorporateCharger } from '../../../utils/queries/corporateChargingSessions';
import { formatDate } from '../../../utils/dateUtils';
import { months } from '../../../utils/chartConstants';
import '../../Reusable/gridStyle.css';
import { Typography, Table, Spin, Pagination } from 'antd';
import { Input } from 'reactstrap';
import { map, get, filter, sumBy, round } from 'lodash-es';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { CSVLink } from 'react-csv';
import { Link } from 'react-router-dom';
import SearchBox from 'components/Common/SearchBox';
import PageSizer from 'components/Common/PageSizer';
import UserDetailCard from '../UserDetailCard';

const { Title, Text } = Typography;

export default function CorporateChargingSessionsGrid({
  CPID,
  filterYear,
  filterMonth,
  showAll = false,
}) {
  const [data, setData] = useState([]);
  const [activeUserPopoverId, setActiveUserPopoverId] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [pageLimit, setPageLimit] = useState(10);
  const [type, setType] = useState('IDTAG');
  const [queryString, setQueryString] = useState('');
  const {
    data: resData,
    isLoading,
    isError,
    refetch,
  } = useSessionListByCorporateCharger({
    CPID,
    offset: (currentPage - 1) * pageLimit,
    limit: pageLimit,
    month: filterMonth,
    year: filterYear,
    query: queryString,
    type: type,
  });
  const { data: dataToExport, refetch: refetchExportData } =
    useSessionListByCorporateCharger({
      CPID,
      offset: (currentPage - 1) * pageLimit,
      limit: pageLimit,
      month: filterMonth,
      year: filterYear,
      query: queryString,
      type: type,
    });

  function onSearch(queryString) {
    setQueryString(queryString);
    setCurrentPage(1);
    refetch();
  }

  function onPageSizeChange(newPageSize) {
    setPageLimit(newPageSize);
  }

  function getFooter() {
    return (
      <div
        style={{
          float: 'right',
          display: 'flex',
          justifyContent: 'flex-end',
          margin: 0,
        }}
      >
        <div style={{ marginTop: 5 }}>
          Total {resData?.total ? resData?.total : 0} records
        </div>
        <Pagination
          current={currentPage}
          defaultCurrent={1}
          pageSize={pageLimit}
          // total={data?.length}
          total={resData?.total}
          onChange={(pageSize) => {
            setCurrentPage(pageSize);
          }}
        />
        <PageSizer
          onChangeHandler={(newPageSize) => {
            onPageSizeChange(newPageSize);
          }}
          selectedPageSize={pageLimit}
        />
      </div>
    );
  }

  function getSummary(tableData) {
    let totalEnergyConsumed = 0;
    // let totalEnergyBilled = 0;
    // let totalAmountConsumed = 0;
    // let totalAmountBilled = 0;

    tableData.forEach(
      ({
        KWH_CONSUMED,
        // KWH_BILLED,
        // AMOUNT_CONSUMED,
        // AMOUNT_BILLED,
      }) => {
        totalEnergyConsumed += KWH_CONSUMED;
        // totalEnergyBilled += KWH_BILLED;
        // totalAmountConsumed += AMOUNT_CONSUMED;
        // totalAmountBilled += AMOUNT_BILLED;
      },
    );
    return tableData?.length === 0 ? null : (
      <Table.Summary fixed>
        <Table.Summary.Row fixed style={{ fontWeight: '600' }}>
          <Table.Summary.Cell index={0} colSpan={6}>
            Total
          </Table.Summary.Cell>
          <Table.Summary.Cell index={6}>
            <Text>
              {totalEnergyConsumed ? `${round(totalEnergyConsumed, 2)} KWh` : 0}
            </Text>
          </Table.Summary.Cell>
          {/* <Table.Summary.Cell index={7}>
          <Text>
            {totalEnergyBilled
              ? `${round(totalEnergyBilled, 2)} KWh`
              : 0}{' '}
          </Text>
        </Table.Summary.Cell>
        <Table.Summary.Cell index={8}>
          <Text>
            {totalAmountConsumed
              ? `₹${totalAmountConsumed / 100}`
              : 0}
          </Text>
        </Table.Summary.Cell>
        <Table.Summary.Cell index={9}>
          <Text>
            {totalAmountBilled ? `₹${totalAmountBilled / 100}` : 0}
          </Text>
        </Table.Summary.Cell> */}
        </Table.Summary.Row>
      </Table.Summary>
    );
  }

  function makeData(sessions) {
    const formattedSessions = map(sessions, (session, s) => ({
      ...session,
      key: s,
    }));
    return formattedSessions;
  }

  const columns = [
    {
      title: 'Id',
      dataIndex: 'TRANSACTIONID',
      render: (text, session) => (
        <>
          {' '}
          <Link to={`/corporate/session/${session?.QUEUEID}`}>
            {session?.TRANSACTIONID}
          </Link>
        </>
      ),
      key: 'TRANSACTIONID',
    },
    {
      title: 'Connector Id',
      dataIndex: 'CONNECTORID',
      render: (text, session) => <> </>,
      key: 'CONNECTORID',
    },
    {
      title: 'ID Tag',
      dataIndex: 'IDTAG',
      render: (text, session, idx) => (
        <>
          <a
            id={`UserPopover_${idx}_${get(session, 'IDTAG')}`}
            onMouseEnter={() => {
              setActiveUserPopoverId(
                `UserPopover_${idx}_${get(session, 'IDTAG')}`,
              );
            }}
          >
            {get(session, 'IDTAG')}
          </a>
          {get(session, 'IDTAG') && (
            <UserDetailCard
              idx={idx}
              detail={{
                NAME: session?.NAME,
                EMAIL: session?.EMAIL,
                PHONE_NUMBER: session?.PHONE_NUMBER,
              }}
              idTag={get(session, 'IDTAG')}
              activePopoverId={activeUserPopoverId}
              isChargerLoading={false}
              onClickOutside={() => {
                setActiveUserPopoverId('');
              }}
            />
          )}
        </>
      ),
      key: 'IDTAG',
    },
    {
      title: 'Started at',
      dataIndex: 'START_TIME',
      render: (text, session) => <>{formatDate(get(session, 'START_TIME'))}</>,
      key: 'START_TIME',
      sorter: (a, b) => new Date(b.START_TIME) - new Date(a.START_TIME),
      defaultSortOrder: 'ascend',
    },
    {
      title: 'Ended at',
      dataIndex: 'END_TIME',
      render: (text, session) => (
        <>
          {!get(session, 'END_TIME') || get(session, 'METER_STOP') === null ? (
            <>In Use</>
          ) : (
            formatDate(get(session, 'END_TIME'))
          )}
        </>
      ),
      key: 'END_TIME',
      sorter: (a, b) => new Date(b.START_TIME) - new Date(a.START_TIME),
      defaultSortOrder: '',
    },
    {
      title: 'Duration',
      dataIndex: '',
      render: (text, session) => (
        <>
          {`${
            moment(session?.END_TIME).diff(
              moment(session?.START_TIME),
              'minute',
            ) || 0
          } min`}
        </>
      ),
      sorter: (a, b) =>
        moment(b?.END_TIME).diff(moment(b?.START_TIME), 'minute', true) -
        moment(a?.END_TIME).diff(moment(a?.START_TIME), 'minute', true),
    },
    {
      title: 'Energy Consumed',
      dataIndex: 'KWH_CONSUMED',
      render: (text, session) => (
        <>
          {get(session, 'KWH_CONSUMED')
            ? `${round(get(session, 'KWH_CONSUMED'), 2)} KWh`
            : '-'}
        </>
      ),
      key: 'KWH_CONSUMED',
      sorter: (a, b) => b?.KWH_CONSUMED - a?.KWH_CONSUMED,
    },
    // {
    //   title: 'Initiated by',
    //   dataIndex: 'AMOUNT_BILLED',
    //   render: (text, session) => (
    //     <>
    //       {/* {get(session, 'AMOUNT_BILLED')
    //         ? `₹${get(session, 'AMOUNT_BILLED') / 100}`
    //         : '-'} */}
    //     </>
    //   ),
    //   key: 'AMOUNT_BILLED',
    // },
    // {
    //   title: 'Energy Billed',
    //   dataIndex: 'KWH_BILLED',
    //   render: (text, session) => (
    //     <>
    //       {get(session, 'KWH_BILLED')
    //         ? `${round(get(session, 'KWH_BILLED'), 2)} KWh`
    //         : '-'}
    //     </>
    //   ),
    //   key: 'KWH_BILLED',
    //   sorter: (a, b) => b?.KWH_BILLED - a?.KWH_BILLED,
    // },
    // {
    //   title: 'Amount Consumed',
    //   dataIndex: 'AMOUNT_CONSUMED',
    //   render: (text, session) => (
    //     <>
    //       {get(session, 'AMOUNT_CONSUMED')
    //         ? `₹${get(session, 'AMOUNT_CONSUMED') / 100}`
    //         : '-'}
    //     </>
    //   ),
    //   key: 'AMOUNT_CONSUMED',
    //   sorter: (a, b) => b?.AMOUNT_CONSUMED - a?.AMOUNT_CONSUMED,
    // },
    // {
    //   title: 'Amount Billed',
    //   dataIndex: 'AMOUNT_BILLED',
    //   render: (text, session) => (
    //     <>
    //       {get(session, 'AMOUNT_BILLED')
    //         ? `₹${get(session, 'AMOUNT_BILLED') / 100}`
    //         : '-'}
    //     </>
    //   ),
    //   key: 'AMOUNT_BILLED',
    //   sorter: (a, b) => b?.AMOUNT_BILLED - a?.AMOUNT_BILLED,
    // },
    // {
    //   title: 'Amount Received',
    //   dataIndex: 'AMOUNT_BILLED',
    //   render: (text, session) => (
    //     <>
    //       {/* {get(session, 'AMOUNT_BILLED')
    //         ? `₹${get(session, 'AMOUNT_BILLED') / 100}`
    //         : '-'} */}
    //     </>
    //   ),
    //   key: 'AMOUNT_BILLED',
    // },
    // {
    //   title: 'Amount Refunded',
    //   dataIndex: 'AMOUNT_REFUNDED',
    //   render: (text, session) => (
    //     <>
    //       {get(session, 'AMOUNT_REFUNDED')
    //         ? `₹${get(session, 'AMOUNT_REFUNDED') / 100}`
    //         : '-'}
    //     </>
    //   ),
    //   key: 'AMOUNT_REFUNDED',
    //   sorter: (a, b) => b?.AMOUNT_REFUNDED - a?.AMOUNT_REFUNDED,
    // },
    // {
    //   title: 'Transaction Status',
    //   dataIndex: 'AMOUNT_BILLED',
    //   render: (text, session) => (
    //     <>
    //       {/* {get(session, 'AMOUNT_BILLED')
    //         ? `₹${get(session, 'AMOUNT_BILLED') / 100}`
    //         : '-'} */}
    //     </>
    //   ),
    //   key: 'AMOUNT_BILLED',
    // },

    // {
    //   title: 'Payment Method',
    //   dataIndex: 'AMOUNT_BILLED',
    //   render: (text, session) => (
    //     <>
    //       {/* {get(session, 'AMOUNT_BILLED')
    //         ? `₹${get(session, 'AMOUNT_BILLED') / 100}`
    //         : '-'} */}
    //     </>
    //   ),
    //   key: 'AMOUNT_BILLED',
    // },
  ];

  const getTitle = () => (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}
    >
      <div>
        <Title level={4}>
          Charging Sessions
          {!showAll &&
            filterMonth &&
            ` (${months[filterMonth - 1]} - ${filterYear})`}
        </Title>
      </div>

      <Input
        type="select"
        name="select"
        id="typeSelect"
        value={type}
        onChange={(e) => {
          setType(e.target.value);
        }}
        style={{
          height: 35,
          width: 300,
          color: '#8898aa',
          padding: 5,
          margin: '0 5px',
          borderRadius: 5,
        }}
      >
        <option value={'IDTAG'}>IDTAG</option>
        <option value={'TRANSACTIONID'}>TRANSACTION ID</option>
      </Input>
      <div style={{ maxWidth: 400 }}>
        <SearchBox
          placeholder="Search by TransactionId or IDTAG"
          onSearch={(qry) => {
            onSearch(qry);
          }}
        />
      </div>
      {dataToExport?.list?.length > 0 && (
        <CSVLink
          data={generateChargingSessionsCsvData()}
          filename="ChargingSessions.csv"
          separator=","
          style={{
            backgroundColor: '#2675b8',
            color: 'white',
            border: '0px solid transparent',
            paddingTop: '10px',
            paddingBottom: '10px',
            paddingLeft: '15px',
            paddingRight: '15px',
            borderRadius: '6px',
            marginBottom: '0px',
            height: '41px',
            marginRight: '10px',
            fontSize: '14px',
            fontWeight: 600,
          }}
        >
          Export as CSV
        </CSVLink>
      )}
    </div>
  );

  const sumByKey = (key) => sumBy(dataToExport, key);

  const generateChargingSessionsCsvData = () => {
    let dataCSV = dataToExport?.list;
    if (!dataCSV.length > 0) return '';
    const meta = [
      { label: 'Id', dataIndex: 'TRANSACTIONID', customValue: '' },
      { label: 'Connector Id', dataIndex: 'CONNECTORID', customValue: '' },
      { label: 'ID Tag', dataIndex: 'IDTAG', customValue: '' },
      {
        label: 'Started at',
        dataIndex: 'START_TIME',
        customValue: (row) =>
          moment(row?.START_TIME).format('D MMM YYYY h:m a'),
      },
      {
        label: 'Ended at',
        dataIndex: 'END_TIME',
        customValue: (row) => moment(row?.END_TIME).format('D MMM YYYY h:m a'),
      },
      {
        label: 'Duration',
        dataIndex: '',
        customValue: (row) =>
          moment(row?.END_TIME).diff(moment(row?.START_TIME), 'minute'),
      },
      {
        label: 'Energy Consumed',
        dataIndex: 'KWH_CONSUMED',
        customValue: (row) =>
          row?.KWH_CONSUMED ? `${round(row?.KWH_CONSUMED, 2)}KWh` : 0,
      },
      // {
      //   label: 'Energy Billed',
      //   dataIndex: 'KWH_BILLED',
      //   customValue: (row) =>
      //     row?.KWH_BILLED ? `${round(row?.KWH_BILLED, 2)}KWh` : 0,
      // },
      // {
      //   label: 'Amount Consumed',
      //   dataIndex: 'AMOUNT_CONSUMED',
      //   customValue: (row) =>
      //     row?.AMOUNT_CONSUMED ? `₹${row?.AMOUNT_CONSUMED / 100}` : 0,
      // },
      // {
      //   label: 'Amount Billed',
      //   dataIndex: 'AMOUNT_BILLED',
      //   customValue: (row) =>
      //     row?.AMOUNT_BILLED ? `₹${row?.AMOUNT_BILLED / 100}` : 0,
      // },
    ];

    let dataString = '';
    meta.forEach((m) => {
      dataString += `${m.label},`;
    });
    dataString = dataString.slice(0, -1);
    dataString += '\n';

    dataCSV.forEach((row) => {
      meta.forEach((m) => {
        dataString += m.customValue
          ? m.customValue(row)
          : get(row, m.dataIndex);
        dataString += ',';
      });
      dataString = dataString.slice(0, -1);
      dataString += '\n';
    });
    const totalEnergyConsumed = sumByKey('KWH_CONSUMED');
    // const totalEnergyBilled = sumByKey('KWH_BILLED');
    // const totalAmountConsumed = sumByKey('AMOUNT_CONSUMED');
    // const totalAmountBilled = sumByKey('AMOUNT_BILLED');

    dataString += `,,,,,Total,${
      totalEnergyConsumed ? `${round(totalEnergyConsumed, 2)} KWh` : 0
    }`;
    return dataString;
  };

  useEffect(() => {
    if (resData?.list?.length > 0) {
      const formattedResData = map(resData?.list, (d) => {
        const dateObj = new Date(d?.START_TIME);
        const m = dateObj?.getMonth();
        const y = dateObj?.getFullYear();
        return { ...d, MONTH: m + 1, YEAR: y };
      });

      // if (!showAll) {
      //   if (filterYear) {
      //     const dataByYear = filter(formattedResData, (row) => {
      //       return row?.YEAR === filterYear;
      //     });
      //     if (filterMonth) {
      //       const dataByMonth = filter(
      //         dataByYear,
      //         (row) => row?.MONTH === filterMonth,
      //       );
      //       setData(dataByMonth || []);
      //     } else {
      //       setData(dataByYear || []);
      //     }
      //   }
      // } else {
      //   setData(resData?.list || []);
      // }
    }
  }, [resData, showAll]);

  return (
    <>
      <Spin tip="Fetching Charging Sessions" spinning={isLoading}>
        <Table
          rowKey="key"
          size="small"
          columns={columns}
          dataSource={makeData(resData?.list)}
          pagination={false}
          scroll={{ y: '40vh' }}
          style={{ border: '1px solid #e7e7e9' }}
          bordered
          title={() => getTitle()}
          summary={(tableData) => getSummary(data)}
          footer={() => getFooter()}
        />
      </Spin>
    </>
  );
}
